import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/* Material Symbols paths are long single strings; keep intact for fidelity. */
/* eslint-disable max-len */

const ID_CARD_OUTLINED_PATH =
    'M560-440h200v-80H560v80Zm0-120h200v-80H560v80ZM200-320h320v-22q0-45-44-71.5T360-440q-72 0-116 26.5T200-342v22Zm216.5-183.5Q440-527 440-560t-23.5-56.5Q393-640 360-640t-56.5 23.5Q280-593 280-560t23.5 56.5Q327-480 360-480t56.5-23.5ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z';

const ID_CARD_FILLED_PATH =
    'M560-440h200v-80H560v80Zm0-120h200v-80H560v80ZM200-320h320v-22q0-45-44-71.5T360-440q-72 0-116 26.5T200-342v22Zm216.5-183.5Q440-527 440-560t-23.5-56.5Q393-640 360-640t-56.5 23.5Q280-593 280-560t23.5 56.5Q327-480 360-480t56.5-23.5ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Z';

/* eslint-enable max-len */

/** Material Symbols `id_card` outlined (FILL=0) */
export const IdCardOutlinedIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 -960 960 960">
        <path d={ID_CARD_OUTLINED_PATH} />
    </SvgIcon>
);

/** Material Symbols `id_card` filled (FILL=1) */
export const IdCardIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 -960 960 960">
        <path d={ID_CARD_FILLED_PATH} />
    </SvgIcon>
);
